import React from "react";
import { useTranslation } from "react-i18next";
import EditRating from "../../components/EditRating";
import { useState } from "react";
import { useEffect } from "react";
import { JobRoleDetailService } from "../../services/JobRoleDetailService";
import { InterviewService } from "../../services/InterviewService";
import { useSideDrawerSearch } from "../../components/SideDrawerSearch";
import JobRoleDetails from "../../components/JobRoleDetailsTree/JobRoleDetails";
import { DropDownMultiCheck } from "../Interview/AdvanceSearch/DropDownMultiCheck";

export default function FilterForm({ searchObject, setSearchObject }) {
  const [businessAreas, setBusinessAreas] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [managers, setManagers] = useState([]);
  const { onChangeFilters } = useSideDrawerSearch();
  useEffect(() => {
    JobRoleDetailService.getAllBusinessAreas().then((result) => {
      setBusinessAreas(result);
    });
    JobRoleDetailService.getAllTechAreas().then((result) => {
      setTechAreas(result);
    });

    InterviewService.GetManagerList().then((result) => {
      setManagers(result);
    });
  }, []);

  useEffect(() => {
    if (searchObject.techAreaId) {
      JobRoleDetailService.getAllTechRoles(searchObject.techAreaId).then(
        (result) => {
          setTechRoles(result);
        }
      );
    }
  }, [searchObject.techAreaId]);

  function onChange(event) {
    const { name, value } = event.target;
    let _searchObject = { ...searchObject };

    if (name === "businessAreaId") {
      _searchObject.businessAreaId = value;
      onChangeFilters(
        name,
        businessAreas.find((x) => x.id === Number(value))?.description
      );
    } else if (name === "techAreaId") {
      onChangeFilters(
        name,
        techAreas.find((x) => x.id === Number(value))?.description
      );
      _searchObject.techAreaId = value;
      _searchObject.techRoleId = "";
    } else if (name === "techRoleId") {
      onChangeFilters(
        name,
        techRoles.find((x) => x.id === Number(value))?.description
      );
      _searchObject.techRoleId = value;
    } else if (name === "managerId") {
      onChangeFilters(
        name,
        managers.find((x) => x.id === Number(value))?.nickname
      );
      _searchObject.managerId = value;
    } else if (name === "nameOrEmail") {
      _searchObject.nameOrEmail = value;
      onChangeFilters(name, value);
    }

    setSearchObject(_searchObject);
  }

  function changeRanting(rating) {
    setSearchObject({ ...searchObject, rating: rating });
    onChangeFilters("rating:", "rating: " + rating);
  }
  function onchangeCandidateBusinessAreas(businessAreas) {
    setSearchObject({
      ...searchObject,
      businessAreas: businessAreas
    });
    onChangeFilters(
      "businessAreas",
      businessAreas.map((x) => x.description).join(" | ")
    );
  }

  let { t } = useTranslation();
  return (
    <div>
      <div className="form-group mt-2">
        <label className="form-label" htmlFor="nameOrEmail">
          {t("Name or Email")}
        </label>
        <input
          type="text"
          className="form-control"
          id="nameOrEmail"
          name="nameOrEmail"
          placeholder={t("Name or Email")}
          value={searchObject.nameOrEmail || ""}
          onChange={onChange}
        />
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Business Area")}</label>
        <DropDownMultiCheck
          dataList={businessAreas}
          selecteds={searchObject.businessAreas || []}
          setSelecteds={onchangeCandidateBusinessAreas}
          label={t("Business Area...")}
          hideSelected={true}
        />
        {/* <select
          id="businessAreaId"
          name="businessAreaId"
          className="form-select"
          onChange={onChange}
          value={searchObject.businessAreaId || ""}
          title={t("Selecione um item da lista.")}
          required
        >
          <option value="" selected>
            {t("Select Business Area...")}
          </option>
          {businessAreas.map((item) => (
            <option key={item.id} value={item.id}>
              {t(item.description)}
            </option>
          ))}
        </select> */}
      </div>

      <JobRoleDetails
        onChange={onChange}
        searchObject={searchObject}
        techAreas={techAreas}
        techRoles={techRoles}
      />

      <div className="form-group mt-2">
        <label className="form-label">{t("Managers")}</label>
        <select
          id="techRoleId"
          name="managerId"
          className="form-select"
          onChange={onChange}
          value={searchObject.managerId || ""}
          title={t("Selecione um item da lista.")}
        >
          <option selected>{t("Select manager...")}</option>
          {managers?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.nickname}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Rating")}</label>

        <EditRating onChange={changeRanting} ratingObj={searchObject} />
      </div>
    </div>
  );
}
